import Vue from "vue";
import Calculator from "@/components/Calculator.vue";

Vue.config.productionTip = false;
Vue.config.devtools = true;

const api = {
  initialize(weight: number, age: number, colors: { theme: string, light: string }): void {
    //console.log(weight, age);

    new Vue({
      components: { Calculator },
      template: `<calculator :weightin="weight" :agein="age" :colors="colors"></calculator>`,
      el: "#vue-infusion-calculator", 
      data() { return { weight, age, colors } }
    });
  }
}

export default api;